function RequestError(message) {
  this.message = message;
  this.stack = new Error('RequestError stack').stack;
}
RequestError.prototype = Object.create(Error.prototype);
RequestError.prototype.name = 'RequestError';
RequestError.prototype.constructor = RequestError;

export default function (context) {
  const { $axios, store, $config, ssrContext, req, route, redirect } = context;

  // const $log = ssrContext && ssrContext.$logger;

  const IGNORED_PATHS = ['/auth/login', '/auth/logout', '/auth/token/refresh'];

  $axios.onRequest((config) => {
    // 1. Add the ngrok bypass header
    // This tells ngrok to skip the "interstitial" warning page
    // config.headers['ngrok-skip-browser-warning'] = 'true';
    // check if the user is authenticated
    rewriteHost(config, $config);

    if (store.state.auth.access_token) {
      // set the Authorization header using the access token
      config.headers.Authorization = 'Bearer ' + store.state.auth.access_token;
    }

    return config;
  });

  $axios.onResponse((response) => {
    const timeElapsed = new Date();
    // Logging
    if (process.server) {
      const url = response.request.res.responseUrl;
      const status = response.data.result || response.status;
      const resultMessage = response.data.resultMessage;

      // if (status != 200) {
      //   $logger.error('API Result ' + status, resultMessage, {
      //     request: url,
      //   });
      // } else {
      //   $logger.info('API Called', {
      //     request: url,
      //     elapsed: timeElapsed,
      //   });
      // }
    }
  });
  $axios.onError((error) => {
    return new Promise(async (resolve, reject) => {
      // ignore certain paths (i.e. paths relating to authentication)
      const isIgnored = IGNORED_PATHS.some((path) => {
        return error?.config?.url.includes(path);
      });

      // get the status code from the response
      const statusCode = error.response ? error.response.status : -1;

      // only handle authentication errors or errors involving the validity of the token
      if ((statusCode === 401 || statusCode === 422) && !isIgnored) {
        // API should return a reason for the error, represented here by the text_code property

        // Example API response:
        // {
        //   status: 'failed',
        //   code: 'token_not_valid',
        //   message: 'The JWT token is expired',
        //   status_code: 401
        // }

        // retrieve the text_code property from the response, or default to null
        const { data: { code } = { code: null } } = error.response || {};

        // get the refresh token from the state if it exists
        const refreshToken = store.state.auth.refresh_token;

        // determine if the error is a result of an expired access token
        // also ensure that the refresh token is present
        if (code === 'token_not_valid' && refreshToken) {
          // see below - consider the refresh process failed if this is a 2nd attempt at the request
          if (error.config.hasOwnProperty('retryAttempts')) {
            // immediately logout if already attempted refresh
            await store.dispatch('auth/logout');

            // redirect the user home
            return redirect('/');
          } else {
            // merge a new retryAttempts property into the original request config to prevent infinite-loop if refresh fails
            const config = { retryAttempts: 1, ...error.config };

            try {
              // attempt to refresh access token using refresh token
              await store.dispatch('auth/refresh');

              // re-run the initial request using the new request config after a successful refresh
              // this response will be returned to the initial calling method
              return resolve($axios(config));
            } catch (e) {
              // catch any error while refreshing the token
              await store.dispatch('auth/logout');

              // redirect the user home
              return redirect('/');
            }
          }
        } else if (code === 'token_not_valid') {
          // catch any other JWT-related error (i.e. malformed token) and logout the user
          await store.dispatch('auth/logout');

          // redirect the user home
          return redirect('/');
        }
      }

      // ignore all other errors, let component or other error handlers handle them
      return reject(error);
    });
  });
}

function rewriteHost(config, $config) {
  const url = config.url;
  const prefix = url
    .split('/')
    .filter((i) => i)
    .shift();

  if (prefix == 'front') {
    config.baseURL = $config.frontUrl;
  } else if (prefix == 'api') {
    config.baseURL = $config.serverApiUrl;
  } else {
    config.baseURL = $config.apiUrl;
  }

  config.withCredentials = false;
}
